"use strict";

import $ from "jquery";

export default function searchBar(scope) {
    $(scope).each(function () {
        const searchForm = $(this);
        const searchToggle = searchForm.find(".js-search-bar-toggle");
        const searchInput = searchForm.find(".js-search-bar-query");
        const langInput = searchForm.find(".js-search-bar-lang");
        const searchTypeahead = searchForm.find(".js-search-bar-typeahead");
        const typeAheadUrl = searchForm.data("typeAhead");
        const minQueryLength = 2;
        const maxSuggestionsLength = 5;
        let queryStash = "";

        function showSuggestions() {
            searchTypeahead.show(0);
        }

        function hideSuggestions() {
            searchTypeahead.empty();
            searchTypeahead.hide(0);
        }

        function toggleSearch() {
            if (searchForm.hasClass("active")) {
                hideSuggestions();
                searchForm.removeClass("active");
            } else {
                searchForm.addClass("active");
                searchInput.focus();
            }
        }

        function setHighlight(suggestion, highlightQueryStash) {
            const specials = /[.*+?|()[\]{}\\$^]/g; // .*+?|()[]{}\$^
            const escaped = highlightQueryStash.replace(specials, "\\$&");
            const regex = new RegExp("(" + escaped + ")", "gi");
            return suggestion.replace(regex, "<b>$1</b>");
        }

        function updateSuggestions(items) {
            searchTypeahead.empty();
            items.forEach(function (suggestion) {
                const highlightResult = setHighlight(suggestion, queryStash); // '<b>' + suggestion.substring(0, queryStash.length) + '</b>' + suggestion.substring(queryStash.length);
                searchTypeahead.append(
                    `<li data-val="${suggestion}">${highlightResult}</li>`,
                );
            });
            showSuggestions();
        }

        function getSuggestions() {
            $.get(
                typeAheadUrl,
                {
                    lang: langInput.val(),
                    query: searchInput.val(),
                    count: maxSuggestionsLength,
                },
                function (data) {
                    const suggestions = data;
                    if (suggestions.length > 0) {
                        updateSuggestions(suggestions);
                    } else {
                        hideSuggestions();
                    }
                },
            );
        }

        function setSuggestionActive(elm) {
            const suggestions = searchTypeahead.find("li");
            suggestions.removeClass("active");
            elm.addClass("active");
        }

        function setSuggestionAsQuery(direction) {
            const suggestions = searchTypeahead.find("li");
            if (suggestions.length) {
                const activeSuggestion = suggestions.filter(".active");
                const activeSuggestionIndex = activeSuggestion.length
                    ? suggestions.index(activeSuggestion)
                    : -1;
                let targetSuggestionIndex = activeSuggestionIndex + direction;
                if (targetSuggestionIndex < 0) {
                    searchInput.val(queryStash);
                    suggestions.removeClass("active");
                } else {
                    if (targetSuggestionIndex >= suggestions.length) {
                        targetSuggestionIndex -= 1;
                    }
                    const targetSuggestion = $(
                        suggestions[targetSuggestionIndex],
                    );
                    setSuggestionActive(targetSuggestion);
                    searchInput.val(targetSuggestion.data("val"));
                }
            }
        }

        function submitSuggestion(elm) {
            const suggestionValue = elm.data("val");
            searchInput.val(suggestionValue);
            hideSuggestions();
            searchForm.submit();
        }

        // Toggle

        searchToggle.on("click", () => {
            toggleSearch();
        });

        // Type ahead

        searchInput.on("keyup", (e) => {
            e.preventDefault();
            switch (e.which) {
                case 27:
                    hideSuggestions();
                    break;
                case 38:
                    setSuggestionAsQuery(-1);
                    break;
                case 40:
                    setSuggestionAsQuery(1);
                    break;
                default:
                    const query = searchInput.val(); // eslint-disable-line
                    queryStash = query;
                    const queryLength = query.length; // eslint-disable-line
                    if (queryLength >= minQueryLength) {
                        getSuggestions();
                    } else {
                        hideSuggestions();
                    }
            }
        });

        searchTypeahead.on("mouseenter", "li", (e) => {
            setSuggestionActive($(e.target));
        });

        searchTypeahead.on("click", "li, b", (e) => {
            submitSuggestion($(e.target).closest("li"));
        });

        // Submit

        searchForm.on("submit", function (e) {
            e.preventDefault();
            const origin = location.origin;
            const action = searchForm.attr("action");
            const query = searchForm.find('[name="query"]').val();
            const newLocation = origin + action + "#/?query=" + query;
            window.location = newLocation;
        });
    });
}
